import { DialogObject } from '@/components/dialog/dialog.types';

export const getApproveConfirmDialog = (action: () => void, toggleVisibility: () => void): DialogObject => ({
  title: 'settings.paymentJustification.dialog.approve.description',
  description: '',
  actions: [
    {
      label: 'settings.paymentJustification.detail.approve',
      variant: 'success',
      onClick: action,
    },
    {
      label: 'settings.paymentJustification.detail.cancel',
      variant: 'secondary',
      onClick: toggleVisibility,
    },
  ],
});

export const getRejectConfirmDialog = (action: () => void, toggleVisibility: () => void): DialogObject => ({
  title: 'settings.paymentJustification.dialog.reject.description',
  description: '',
  actions: [
    {
      label: 'settings.paymentJustification.detail.reject',
      variant: 'danger',
      onClick: action,
    },
    {
      label: 'settings.paymentJustification.detail.cancel',
      variant: 'secondary',
      onClick: toggleVisibility,
    },
  ],
});
